import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63dc7be0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layout" }
const _hoisted_2 = {
  key: 0,
  class: "header-nav"
}
const _hoisted_3 = { class: "account-info" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "My NFTs", -1))
const _hoisted_5 = { class: "container" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bg-mask" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_account_connect = _resolveComponent("account-connect")!
  const _component_chain_tag = _resolveComponent("chain-tag")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_layout_header = _resolveComponent("layout-header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_layout_footer = _resolveComponent("layout-footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_layout_header, { class: "header" }, {
      right: _withCtx(() => [
        _createElementVNode("div", {
          class: "header-right",
          style: _normalizeStyle({flex: _ctx.userInfo.address ? 1: 0})
        }, [
          (_ctx.userInfo.address)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_account_connect, {
                    address: _ctx.userInfo.address
                  }, null, 8, ["address"]),
                  (_ctx.userInfo.chainId)
                    ? (_openBlock(), _createBlock(_component_chain_tag, {
                        key: 0,
                        chainId: _ctx.userInfo.chainId
                      }, null, 8, ["chainId"]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_router_link, {
                  to: { name: 'list' },
                  class: "c-button"
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ], 4)
      ]),
      _: 1
    }),
    _createElementVNode("main", _hoisted_5, [
      _createVNode(_component_router_view)
    ]),
    _createVNode(_component_layout_footer),
    _hoisted_6
  ]))
}